module.exports = __webpack_public_path__ + "img/lv0-1.8ad80911.png";